var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardCustomerInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H5M11 9H5M11 13H7M1 1H15V19L13.968 18.116C13.6055 17.8053 13.1439 17.6346 12.6665 17.6346C12.1891 17.6346 11.7275 17.8053 11.365 18.116L10.333 19L9.302 18.116C8.93946 17.8051 8.47761 17.6342 8 17.6342C7.52239 17.6342 7.06054 17.8051 6.698 18.116L5.667 19L4.635 18.116C4.27253 17.8053 3.81088 17.6346 3.3335 17.6346C2.85611 17.6346 2.39447 17.8053 2.032 18.116L1 19V1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCustomerInvoices);
export default __webpack_public_path__ + "static/media/dashboard_customer_invoices.ab32a74163f02aac8fa83fe2d48d08a5.svg";
export { ForwardRef as ReactComponent };